export const DEFAULT_PAGE_SIZE = 10;

/** Cards per row at desktop width. Sections multiply it by their row count to get a page size. */
export const LIBRARY_CARDS_PER_ROW = 4;

// External docs/reference links shown in the Getting Started build drawers.
export const GETTING_STARTED_LINKS = {
    SKILLS: 'https://github.com/UiPath/skills',
    CLI: 'https://docs.uipath.com/uipath-cli/standalone/latest/user-guide/about-uipath-cli',
    SDK: 'https://uipath.github.io/uipath-typescript/',
} as const;

// Tag values used to scope and pin coded (Insights) dashboards.
export const DASHBOARD_TAGS = {
    GOVERNANCE: 'governance',
    PINNED: 'dashboard',
} as const;

export const POLICY_TABS = {
    PRODUCT: 'product',
    ACCESS: 'access',
} as const;

// `Deleted` is stripped server-side before the grid sees rows.
export enum AccessPolicyStatus {
    Active = 'Active',
    Disabled = 'Disabled',
    Simulated = 'Simulated',
}

// URL-persisted filter shape; tabs ignore fields they don't use.
export interface PolicyLibraryFilter {
    search: string;
    page: number;
    pageSize: number;
    productName: string;
    status: string;
    // Product tab only. Rides inside the compressed filter blob rather than a separate URL param.
    packId: string;
}

export const DEFAULT_POLICY_LIBRARY_FILTER: PolicyLibraryFilter = {
    search: '',
    page: 0,
    pageSize: DEFAULT_PAGE_SIZE,
    productName: '',
    status: '',
    packId: '',
};
